import React from 'react'
import Link from 'gatsby-link'

const Header = ({ siteTitle }) => (
  <div className="container header">
    <div className="logo-box">
      <Link to="/">
        <img src="/img/logo.png" alt="Flying Seal" />
      </Link>
    </div>
    <nav className="nav">
      <a href="https://app.flyingseal.me" className="sign-in-header" target="_blank">Sign In</a>  
    </nav>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js